import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Navbar.css';
import logo from '../assets/logo.png';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const navLinks = [
    { path: "/", label: "Home", exact: true },
    { path: "/sectors", label: "Adam Sectors" },
    { path: "/about", label: "About Adam" },
    { path: "/announcements", label: "Announcements" },
    { path: "/platforms", label: "Platforms" },
    { path: "/contact", label: "Contact" }
  ];

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo">
          <Link to="/" onClick={closeMenu}>
            <img src={logo} alt="ADAM Holding Logo" className="navbar-logo-img" />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <ul className="navbar-desktop">
          {navLinks.map((link, index) => (
            <li key={index}>
              <Link 
                to={link.path} 
                className={`navbar-link ${isActive(link.path)}`}
                onClick={closeMenu}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Mobile Menu Toggle */}
        <div className="navbar-toggle" onClick={toggleMenu}>
          {menuOpen ? <FaTimes className="navbar-toggle-icon" /> : <FaBars className="navbar-toggle-icon" />}
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className={`navbar-mobile ${menuOpen ? 'navbar-mobile--open' : ''}`}>
        <div className="navbar-mobile-content">
          <ul className="navbar-mobile-links">
            {navLinks.map((link, index) => (
              <li key={index}>
                <Link 
                  to={link.path} 
                  className={`navbar-mobile-link ${isActive(link.path)}`}
                  onClick={closeMenu}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className="navbar-mobile-cta">
            <a href="tel:+905380772631" className="navbar-mobile-phone">
              📞 +90 538 077 26 31
            </a>
            <a href="mailto:info@adamholdingunion.com" className="navbar-mobile-email">
              📧 info@adamholdingunion.com
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;